import { DEFAULT_PRODUCT_TYPE } from '../constants';

const VALID_PRODUCT_TYPES = [
  'accidental-medical',
  'vhis',
  'medical',
  'life',
  'critical-illness',
  'parent-medical',
];
const PRODUCT_TYPE_MAPPING_KEY: Record<string, string> = {
  'accidental-medical': 'productMeta.accidentalMedical.name',
  vhis: 'productMeta.vhis.name',
  medical: 'productMeta.medical.name',
  life: 'productMeta.life.name',
  'critical-illness': 'productMeta.criticalIllness.name',
  'parent-medical': 'productMeta.parent-medical.name',
};
const DESCRIPTION_MAPPING_KEY: Record<string, string> = {
  'accidental-medical': 'productMeta.accidentalMedical.description',
  vhis: 'productMeta.vhis.description',
  medical: 'productMeta.medical.description',
  life: 'productMeta.life.description',
  'critical-illness': 'productMeta.criticalIllness.description',
  'parent-medical': 'productMeta.parent-medical.description',
};

export const getSafeProductType = (type: string) =>
  VALID_PRODUCT_TYPES.includes(type) ? type : DEFAULT_PRODUCT_TYPE;

export const getTextByProduct = (type: string) => {
  const productType = getSafeProductType(type);

  const nameKey = PRODUCT_TYPE_MAPPING_KEY[productType];
  const descriptionKey = DESCRIPTION_MAPPING_KEY[productType];

  return {
    nameKey,
    descriptionKey,
  };
};
